/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Career_2Inputs */

const en_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Head professional, Des Moines Driving Range (1994-present); owner since 2002`)
};

const es_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional titular, Des Moines Driving Range (1994-presente); propietario desde 2002`)
};

const de_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chefprofi, Des Moines Driving Range (seit 1994); Eigentümer seit 2002`)
};

const zh_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range 首席职业教练（1994 年至今）；自 2002 年起任业主`)
};

const ar_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محترف رئيسي في Des Moines Driving Range منذ 1994، ومالك المنشأة منذ 2002`)
};

const fr_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionnel en chef, Des Moines Driving Range (1994-présent); propriétaire depuis 2002`)
};

const vi_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyên gia trưởng, Des Moines Driving Range (1994-nay); chủ sở hữu từ 2002`)
};

const sw_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mtaalamu mkuu, Des Moines Driving Range (1994-sasa); mmiliki tangu 2002`)
};

const th_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หัวหน้าโปรกอล์ฟ, Des Moines Driving Range (1994-ปัจจุบัน); เจ้าของตั้งแต่ปี 2002`)
};

const bs_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glavni profesionalac, Des Moines Driving Range (1994-danas); vlasnik od 2002.`)
};

const ja_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘッドプロ、Des Moines Driving Range（1994年～現在）。2002年よりオーナー`)
};

const ko_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헤드 프로, Des Moines Driving Range (1994–현재); 2002년부터 소유주`)
};

const pt_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profissional-chefe, Des Moines Driving Range (1994 até hoje); proprietário desde 2002`)
};

const it_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionista capo, Des Moines Driving Range (1994-presente); proprietario dal 2002`)
};

const sv_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledande golfprofessional, Des Moines Driving Range (1994–i dag); ägare sedan 2002`)
};

const nl_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofdprofessional, Des Moines Driving Range (1994-heden); eigenaar sinds 2002`)
};

const da_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledende golfprofessionel, Des Moines Driving Range (1994–i dag); ejer siden 2002`)
};

const nb_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledende golfprofesjonell, Des Moines Driving Range (1994–i dag); eier siden 2002`)
};

const fi_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pääammattilainen, Des Moines Driving Range (1994–nykyään); omistaja vuodesta 2002`)
};

const pl_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Główny profesjonalista, Des Moines Driving Range (od 1994 do dziś); właściciel od 2002`)
};

const ru_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главный профессионал, Des Moines Driving Range (1994-настоящее время); владелец с 2002 года`)
};

const tr_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baş profesyonel, Des Moines Driving Range (1994-günümüz); 2002 yılından beri sahibi`)
};

const hi_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हेड प्रोफेशनल, Des Moines Driving Range (1994-वर्तमान); 2002 से मालिक`)
};

const id_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kepala profesional, Des Moines Driving Range (1994-sekarang); pemilik sejak 2002`)
};

const ms_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional utama, Des Moines Driving Range (1994-kini); pemilik sejak 2002`)
};

const cs_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní profesionál, Des Moines Driving Range (1994–dosud); majitel od roku 2002`)
};

const el_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικεφαλής επαγγελματίας, Des Moines Driving Range (1994-σήμερα)· ιδιοκτήτης από το 2002`)
};

const he_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מקצוען ראשי, Des Moines Driving Range (1994–היום); בעלים מאז 2002`)
};

const af_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofprofessional, Des Moines Driving Range (1994 tot hede); eienaar sedert 2002`)
};

const hu_about_content_career_2 = /** @type {(inputs: About_Content_Career_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezető szakember, Des Moines Driving Range (1994- jelen); tulajdonos 2002 óta`)
};

/**
* | output |
* | --- |
* | "Head professional, Des Moines Driving Range (1994-present); owner since 2002" |
*
* @param {About_Content_Career_2Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_career_2 = /** @type {((inputs?: About_Content_Career_2Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Career_2Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_career_2(inputs)
	if (locale === "de") return de_about_content_career_2(inputs)
	if (locale === "zh") return zh_about_content_career_2(inputs)
	if (locale === "ar") return ar_about_content_career_2(inputs)
	if (locale === "fr") return fr_about_content_career_2(inputs)
	if (locale === "vi") return vi_about_content_career_2(inputs)
	if (locale === "sw") return sw_about_content_career_2(inputs)
	if (locale === "th") return th_about_content_career_2(inputs)
	if (locale === "bs") return bs_about_content_career_2(inputs)
	if (locale === "ja") return ja_about_content_career_2(inputs)
	if (locale === "ko") return ko_about_content_career_2(inputs)
	if (locale === "pt") return pt_about_content_career_2(inputs)
	if (locale === "it") return it_about_content_career_2(inputs)
	if (locale === "sv") return sv_about_content_career_2(inputs)
	if (locale === "nl") return nl_about_content_career_2(inputs)
	if (locale === "da") return da_about_content_career_2(inputs)
	if (locale === "nb") return nb_about_content_career_2(inputs)
	if (locale === "fi") return fi_about_content_career_2(inputs)
	if (locale === "pl") return pl_about_content_career_2(inputs)
	if (locale === "ru") return ru_about_content_career_2(inputs)
	if (locale === "tr") return tr_about_content_career_2(inputs)
	if (locale === "hi") return hi_about_content_career_2(inputs)
	if (locale === "id") return id_about_content_career_2(inputs)
	if (locale === "ms") return ms_about_content_career_2(inputs)
	if (locale === "cs") return cs_about_content_career_2(inputs)
	if (locale === "el") return el_about_content_career_2(inputs)
	if (locale === "he") return he_about_content_career_2(inputs)
	if (locale === "af") return af_about_content_career_2(inputs)
	if (locale === "hu") return hu_about_content_career_2(inputs)
	return en_about_content_career_2(inputs)
});